var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgResize = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1566 10.725C21.4561 10.425 21.9418 10.425 22.2413 10.725C22.5409 11.0251 22.5409 11.5115 22.2413 11.8116L10.3094 23.7637C10.0098 24.0637 9.52419 24.0637 9.22465 23.7637C8.92512 23.4636 8.92512 22.9771 9.22465 22.6771L21.1566 10.725Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6906 17.2557C22.9902 16.9556 23.4758 16.9556 23.7753 17.2557C24.0749 17.5557 24.0749 18.0422 23.7753 18.3422L18.3517 23.775C18.0522 24.075 17.5666 24.075 17.267 23.775C16.9675 23.4749 16.9675 22.9885 17.267 22.6884L22.6906 17.2557Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/resize.0abdcba6cbe7cd8661bceed9e37cbec8.svg";